import { render, staticRenderFns } from "./QrPricingWidget.vue?vue&type=template&id=7cb1b3ec&scoped=true"
import script from "./QrPricingWidget.vue?vue&type=script&lang=js"
export * from "./QrPricingWidget.vue?vue&type=script&lang=js"
import style0 from "./QrPricingWidget.vue?vue&type=style&index=0&id=7cb1b3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb1b3ec",
  null
  
)

export default component.exports